/** Generated from ETokenStyleClass.java. Do not modify this file! */


export type ETokenStyleClassEntry = 'KEYWORD' | 'LITERAL' | 'IDENTIFIER' | 'OPERATOR' | 'DELIMITER' | 'COMMENT' | 'DOC_COMMENT' | 'ANNOTATION' | 'SPECIAL' | 'ERROR' | 'SYNTHETIC' | 'WHITESPACE' | 'PLAIN_TEXT' | 'FILTERED' | 'COMMENT_LINK' | 'BROKEN_COMMENT_LINK' | 'ISSUE_REFERENCE' | 'SEARCH_HIGHLIGHT';

export class ETokenStyleClass {
	static readonly KEYWORD = new ETokenStyleClass(0, 'KEYWORD');
	static readonly LITERAL = new ETokenStyleClass(1, 'LITERAL');
	static readonly IDENTIFIER = new ETokenStyleClass(2, 'IDENTIFIER');
	static readonly OPERATOR = new ETokenStyleClass(3, 'OPERATOR');
	static readonly DELIMITER = new ETokenStyleClass(4, 'DELIMITER');
	static readonly COMMENT = new ETokenStyleClass(5, 'COMMENT');
	static readonly DOC_COMMENT = new ETokenStyleClass(6, 'DOC_COMMENT');
	static readonly ANNOTATION = new ETokenStyleClass(7, 'ANNOTATION');
	static readonly SPECIAL = new ETokenStyleClass(8, 'SPECIAL');
	static readonly ERROR = new ETokenStyleClass(9, 'ERROR');
	static readonly SYNTHETIC = new ETokenStyleClass(10, 'SYNTHETIC');
	static readonly WHITESPACE = new ETokenStyleClass(11, 'WHITESPACE');
	static readonly PLAIN_TEXT = new ETokenStyleClass(12, 'PLAIN_TEXT');
	static readonly FILTERED = new ETokenStyleClass(13, 'FILTERED');
	static readonly COMMENT_LINK = new ETokenStyleClass(14, 'COMMENT_LINK');
	static readonly BROKEN_COMMENT_LINK = new ETokenStyleClass(15, 'BROKEN_COMMENT_LINK');
	static readonly ISSUE_REFERENCE = new ETokenStyleClass(16, 'ISSUE_REFERENCE');
	static readonly SEARCH_HIGHLIGHT = new ETokenStyleClass(17, 'SEARCH_HIGHLIGHT');
	static readonly values = [
		ETokenStyleClass.KEYWORD,
		ETokenStyleClass.LITERAL,
		ETokenStyleClass.IDENTIFIER,
		ETokenStyleClass.OPERATOR,
		ETokenStyleClass.DELIMITER,
		ETokenStyleClass.COMMENT,
		ETokenStyleClass.DOC_COMMENT,
		ETokenStyleClass.ANNOTATION,
		ETokenStyleClass.SPECIAL,
		ETokenStyleClass.ERROR,
		ETokenStyleClass.SYNTHETIC,
		ETokenStyleClass.WHITESPACE,
		ETokenStyleClass.PLAIN_TEXT,
		ETokenStyleClass.FILTERED,
		ETokenStyleClass.COMMENT_LINK,
		ETokenStyleClass.BROKEN_COMMENT_LINK,
		ETokenStyleClass.ISSUE_REFERENCE,
		ETokenStyleClass.SEARCH_HIGHLIGHT
	];



	private constructor (
		public readonly ordinal: number,
		public readonly name: ETokenStyleClassEntry,

	){
	}

	toString() {
		return this.name;
	}

	/** Returns the enum value of the provided enum entry. */
	public static valueOf(entry: ETokenStyleClassEntry): ETokenStyleClass;
	/** Returns the enum value of the provided enum entry. Returns undefined if entry was undefined. */
	public static valueOf(entry: ETokenStyleClassEntry | undefined): ETokenStyleClass | undefined;
	public static valueOf(entry: ETokenStyleClassEntry | undefined): ETokenStyleClass | undefined {
		if (entry === undefined) {
			return undefined;
		}
		return ETokenStyleClass[entry];
	}
}

